import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import rasmus from "images/employees/rasmus.jpg"
import dan from "images/employees/dan.jpg"
import hamid from "images/employees/hamid.jpg"
import jimmy from "images/employees/jimmy.jpg"
import jonas from "images/employees/jonas.jpg"
import kalle from "images/employees/kalle.jpg"
import magnus from "images/employees/magnus.jpg"
import emil from "images/employees/emil.jpg"

export const TeamMember = ({ name, position, img }) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <img
        className={styles.image}
        src={img}
        alt={`${name}, ${position} på SAITS`}
      />
    </div>
    <div className={styles.name}>{name}</div>
    <div className={styles.role}>{position}</div>
  </div>
)

class TeamMembers extends React.Component {
  render() {
    return (
      <div className={cx(styles.teamContainer, this.props.className)}>
        {teamMembers.map(tm => (
          <TeamMember key={tm.name} {...tm} />
        ))}
      </div>
    )
  }
}

export const teamMembers = [
  {
    name: "Rasmus Sandström",
    position: "VD",
    img: rasmus,
  },
  {
    name: "Dan Andréasson",
    position: "Utvecklingschef",
    img: dan,
  },
  {
    name: "Jimmy Höglund",
    position: "Utvecklare",
    img: jimmy,
  },
  {
    name: "Hamid Abshari",
    position: "Interaktionsdesigner",
    img: hamid,
  },
  {
    name: "Kalle Lundgren",
    position: "Utvecklare",
    img: kalle,
  },
  {
    name: "Jonas Renngård",
    position: "Utvecklare",
    img: jonas,
  },
  {
    name: "Magnus Pastuhoff",
    position: "Utvecklare",
    img: magnus,
  },
  {
    name: "Emil Lindström",
    position: "Utvecklare",
    img: emil,
  },
]

export default TeamMembers



// WEBPACK FOOTER //
// ./src/components/JobDescription/Team/TeamMembers/index.jsx